import React, { Fragment } from 'react'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import { Link, useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'
import { withStyles, withWidth } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useFooterStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#faf7fc',
    borderTop: '1px solid #e6deed',
    marginTop: theme.spacing(6),
    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(3),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  link: {
    color: '#6a607b',
    display: 'block',
    marginBottom: theme.spacing(0.75),
    textDecoration: 'none',
    '&:hover': {
      color: '#72568e',
      textDecoration: 'underline',
    },
  },
  columnTitle: {
    fontWeight: 700,
    marginBottom: theme.spacing(1.5),
    color: '#403650',
  },
  tagline: {
    color: '#6a607b',
    marginTop: theme.spacing(1),
    maxWidth: 280,
  },
  copyright: {
    marginTop: theme.spacing(4),
    paddingTop: theme.spacing(2),
    borderTop: '1px solid rgba(0,0,0,0.06)',
    color: '#7a8068',
    fontSize: '0.875rem',
  },
}))

function FooterContent() {
  const classes = useFooterStyles()
  const location = useLocation()
  if (/^\/story\/(?!create)/.test(location.pathname)) return null

  return (
    <footer className={classes.root}>
      <Grid container spacing={4} justify="space-between">
        <Grid item xs={12} md={4}>
          <Link to="/">
            <img
              src="/media/logo.png"
              width={72}
              height="auto"
              alt="WeeStoryWorld"
              style={{ cursor: 'pointer' }}
            />
          </Link>
          <Typography variant="body2" className={classes.tagline}>
            Magical stories, gentle planning, and a library built for little
            readers and the grown-ups who love them.
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="subtitle1" className={classes.columnTitle}>
            Explore
          </Typography>
          <Link to="/tonight" className={classes.link}>
            Tonight
          </Link>
          <Link to="/library" className={classes.link}>
            Library
          </Link>
          <Link to="/blog" className={classes.link}>
            Blog
          </Link>
          <Link to="/community" className={classes.link}>
            Community
          </Link>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="subtitle1" className={classes.columnTitle}>
            Legal
          </Typography>
          <Link to="/terms" className={classes.link}>
            Terms
          </Link>
          <Link to="/privacy" className={classes.link}>
            Privacy
          </Link>
        </Grid>
      </Grid>
      <Typography
        component="p"
        variant="body2"
        align="center"
        className={classes.copyright}
      >
        © 2026 WeeStoryWorld. All rights reserved.
      </Typography>
    </footer>
  )
}

function Footer() {
  return (
    <Fragment>
      <div className="home-page mt-5">
        <FooterContent />
      </div>
    </Fragment>
  )
}

const styles = (theme) => ({
  extraLargeButtonLabel: {
    fontSize: theme.typography.body1.fontSize,
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.h6.fontSize,
    },
  },
  extraLargeButton: {
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    [theme.breakpoints.up('xs')]: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
    [theme.breakpoints.up('lg')]: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
  },
  card: {
    boxShadow: theme.shadows[4],
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('xs')]: {
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
    },
    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing(5),
      paddingBottom: theme.spacing(5),
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
    },
    [theme.breakpoints.up('md')]: {
      paddingTop: theme.spacing(5.5),
      paddingBottom: theme.spacing(5.5),
      paddingLeft: theme.spacing(5),
      paddingRight: theme.spacing(5),
    },
    [theme.breakpoints.up('lg')]: {
      paddingTop: theme.spacing(6),
      paddingBottom: theme.spacing(6),
      paddingLeft: theme.spacing(6),
      paddingRight: theme.spacing(6),
    },
    [theme.breakpoints.down('lg')]: {
      width: 'auto',
    },
  },
  wrapper: {
    position: 'relative',
    backgroundColor: theme.palette.secondary.main,
    paddingBottom: theme.spacing(2),
  },
  image: {
    maxWidth: '100%',
    verticalAlign: 'middle',
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[4],
  },
  container: {
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(12),
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(9),
    },
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(6),
    },
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(3),
    },
  },
  containerFix: {
    [theme.breakpoints.up('md')]: {
      maxWidth: 'none !important',
    },
  },
  waveBorder: {
    paddingTop: theme.spacing(4),
  },
})

Footer.propTypes = {
  classes: PropTypes.object,
  width: PropTypes.string,
  theme: PropTypes.object,
}

export default withWidth()(withStyles(styles, { withTheme: true })(Footer))
